// extracted by mini-css-extract-plugin
export default {"custom_textarea":"normal_m_custom_textarea__HPm-0"};